/* Corta y Recorta: load rotating media only where the visitor can see it. */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  /* 24-sep-2026: la rotación arranca con el primer gesto del visitante (o 5 s tras load), vía
     window.cyrDefer (snippet cyr-defer). La primera imagen se ve igual desde el principio; así la
     carga no descarga las siguientes ni cambia la pantalla mientras se está pintando. */
  const engaged = new Promise(resolve => (window.cyrDefer ? window.cyrDefer(resolve) : resolve()));
  const instances = new WeakMap();
  const imageCache = new Map();
  function ready(url) {
    if (!url) return Promise.resolve();
    if (!imageCache.has(url)) {
      const image = new Image(); image.fetchPriority = 'low';
      const promise = new Promise((resolve, reject) => {
        image.onload = () => (image.decode ? image.decode().catch(() => {}) : Promise.resolve()).then(resolve);
        image.onerror = () => { imageCache.delete(url); reject(new Error('Image unavailable')); };
        image.src = url;
      });
      imageCache.set(url, promise);
    }
    return imageCache.get(url);
  }
  function revealImage(image) {
    const url = image.dataset.cyrSrc;
    if (url) { image.src = url; delete image.dataset.cyrSrc; }
    if (image.complete && image.naturalWidth) return Promise.resolve();
    return new Promise((resolve, reject) => {
      image.addEventListener('load', resolve, {once:true});
      image.addEventListener('error', reject, {once:true});
    });
  }
  function watch(element, start, stop) {
    if (instances.has(element)) return;
    let visible = false;
    const update = () => visible && !document.hidden ? start() : stop();
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting; update();
    }, {rootMargin: '300px 0px'}); /* 24-sep-2026: empieza 300 px antes de entrar en pantalla, así la foto ya está al llegar */
    observer.observe(element);
    document.addEventListener('visibilitychange', update);
    instances.set(element, () => { observer.disconnect(); document.removeEventListener('visibilitychange', update); stop(); });
  }
  function carousel(element, selector, duration, background) {
    const slides = [...element.querySelectorAll(selector)];
    if (!slides.length) return;
    let index = 0, running = false, timer, generation = 0;
    const schedule = () => {
      if (!running || reduced.matches || slides.length < 2) return;
      timer = setTimeout(async () => {
        const ticket = generation, next = (index + 1) % slides.length, slide = slides[next];
        const url = background ? slide.dataset.bg : slide.dataset.cyrSrc || slide.currentSrc;
        try {
          await ready(url);
          if (!running || ticket !== generation || !element.isConnected) return;
          if (background && url) { slide.style.backgroundImage = `url("${url}")`; delete slide.dataset.bg; }
          else if (!background) await revealImage(slide);
          if (!running || ticket !== generation) return;
          slides[index].classList.remove('active'); slide.classList.add('active'); index = next;
        } catch (_) { /* Keep the current complete image if the next fails. */ }
        if (ticket === generation) schedule();
      }, duration);
    };
    watch(element, async () => {
      if (running) return; running = true; const ticket = ++generation;
      try { if (!background) await revealImage(slides[index]); } catch (_) {}
      await engaged;
      if (running && ticket === generation) schedule();
    }, () => { running = false; generation++; clearTimeout(timer); });
  }
  function wall(element) {
    const data = element.parentElement.querySelector('[data-cyr-art-database]');
    if (!data) return;
    let art; try { art = JSON.parse(data.textContent); } catch (_) { return; }
    const slots = [...element.querySelectorAll('.js-live-slot')];
    let running = false, timer, generation = 0;
    const schedule = () => {
      if (!running || reduced.matches || art.length <= slots.length) return;
      timer = setTimeout(async () => {
        const ticket = generation;
        const used = new Set(slots.map(s => new URL(s.href, location.href).pathname));
        const available = art.filter(a => !used.has(new URL(a.url, location.href).pathname));
        if (available.length) {
          const next = available[Math.floor(Math.random()*available.length)];
          const slot = slots[Math.floor(Math.random()*slots.length)];
          try { await ready(next.img);
            if (!running || ticket !== generation || !element.isConnected) return;
            const image = slot.querySelector('img');
            image.src = next.img; image.alt = next.title; slot.href = next.url;
          } catch (_) {}
        }
        if (ticket === generation) schedule();
      }, 2500);
    };
    watch(element, async () => {
      if (running) return; running = true; const ticket = ++generation;
      await Promise.allSettled(slots.map(slot => revealImage(slot.querySelector('img'))));
      await engaged;
      if (running && ticket === generation) schedule();
    }, () => { running = false; generation++; clearTimeout(timer); });
  }
  function init(root = document) {
    root.querySelectorAll('#cr-brand-hero-bottom-text .cr-slider-background').forEach(el => carousel(el, '.cr-slide-bg', 6000, true));
    root.querySelectorAll('.rotating-stack').forEach(el => carousel(el, '.cr-zg-img', Number(el.dataset.cyrInterval) || 3000, false));
    root.querySelectorAll('.cr-living-grid').forEach(wall);
    root.querySelectorAll('video[data-cyr-video]').forEach(video => watch(video, () => {
      if (!video.dataset.cyrLoaded) {
        video.querySelectorAll('source[data-cyr-src]').forEach(s => {s.src=s.dataset.cyrSrc;delete s.dataset.cyrSrc;});
        video.dataset.cyrLoaded='true'; video.load();
      }
      if (!reduced.matches) video.play().catch(() => {video.controls=true;}); else video.controls=true;
    }, () => video.pause()));
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('*').forEach(el=>instances.get(el)?.()));
})();
